/**
 * @description
 * Triggers the SET_TRANSACTION_TYPE_INDEX mutation.
 * Used to change the selected transaction type for the current transaction
 * @param {*} param
 * @param {*} transactionType
 */
const setTransactionType = function({ commit, dispatch }, transTypeID) {
    commit('SET_TRANSACTION_TYPE_INDEX', transTypeID - 1)
    dispatch('CartModule/refreshItems', {}, { root: true })
    dispatch('CustomerModule/checkDataStatus', {}, { root: true })
    if (transTypeID === 5)
        dispatch(
            'CartModule/setGlobalDiscount',
            { percentage_discount: 16 },
            { root: true }
        )
}

const switchTransactionType = function({ commit, dispatch }) {
    commit('SWITCH_TRANSACTION_TYPE')
    dispatch('CartModule/refreshItems', {}, { root: true })
    dispatch('CustomerModule/checkDataStatus', {}, { root: true })
}

const toggleAuthMode = ({ commit }, bool) => {
    commit('SET_WAIT_AUTH', bool)
}

const setForcePrint = ({ commit }, object) => {
    commit('SET_FORCE_PRINT', object)
}

const setShowMenu = ({ commit }, bool) => {
    commit('SET_SHOW_MENU', bool)
}

const setShowSearchType = ({ commit }, bool) => {
    commit('SET_SHOW_SEARCH_TYPE', bool)
}

const setShowInternalCodeSearch = ({ commit }, bool) => {
    commit('SET_SHOW_INTERNAL_CODE_SEARCH', bool)
}

const setShowMultiSelectSearch = ({ commit }, bool) => {
    commit('SET_SHOW_MULTI_SELECT_SEARCH', bool)
}

const setEditMode = ({ commit }, bool) => commit('SET_EDIT_MODE', bool)

const setRecoveredStorePickup = ({ commit }, bool) =>
    commit('SET_RECOVERED_STORE_PICKUP', bool)

const setRecoveredOcNumber = ({ commit }, number) =>
    commit('SET_RECOVERED_OC_NUMBER', number)

const setIsEditingDispatchRequest = ({ commit }, bool) =>
    commit('SET_IS_EDITING_DISPATCH_REQUEST', bool)
const setEditedDispatchRequestNumber = ({ commit }, number) =>
    commit('SET_EDITED_DISPATCH_REQUEST_NUMBER', number)
const setEditingOrigin = ({ commit }, number) =>
    commit('SET_EDITING_ORIGIN', number)
const setEditingStorePickup = ({ commit }, bool) =>
    commit('SET_EDITING_STORE_PICKUP', bool)

// SET_EDITING_ORIGIN,
// SET_EDITING_STORE_PICKUP,

const resetState = function({ commit }) {
    commit('RESET_STATE')
}

export default {
    setRecoveredStorePickup,
    setRecoveredOcNumber,
    setTransactionType,
    resetState,
    switchTransactionType,
    toggleAuthMode,
    setForcePrint,
    setShowMenu,
    setShowSearchType,
    setShowInternalCodeSearch,
    setShowMultiSelectSearch,
    setEditMode,
    setIsEditingDispatchRequest,
    setEditedDispatchRequestNumber,
    setEditingOrigin,
    setEditingStorePickup,
}
